import { Observable } from 'rxjs';
import { MedService, DataSourceResponse } from '../../models';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';

@Injectable({ providedIn: 'root' })
export class MedServiceService extends ApiService {
  endPoint = '/api/medservices';
  create(model: MedService) {
    return this.http.post(`${this.commonBaseURL}${this.endPoint}`, model);
  }

  update(id: string, model: MedService) {
    return this.http.put(`${this.commonBaseURL}${this.endPoint}/${id}`, model);
  }

  delete(id: string) {
    return this.http.delete<any>(`${this.commonBaseURL}${this.endPoint}/${id}`);
  }
  deleteRange(ids: string[]) {
    return this.http.post<any>(`${this.commonBaseURL}${this.endPoint}/deleteRange`, ids);
  }

  get(id: string): Observable<MedService> {
    return this.http.get<MedService>(`${this.commonBaseURL}${this.endPoint}/${id}`);
  }

  getList(queryParams: any): Observable<DataSourceResponse<MedService>> {
    const params = new HttpParamsEncoder().encode(queryParams);

    return this.http.get<any>(`${this.commonBaseURL}${this.endPoint}`, { params });
  }
}
